import FilterSelect from "@/components/FilterSelect";
import FilterGroup from "@/components/FilterSelect/FilterGroup";
import HBIcon from "@/components/HBIcon";
import { useToggle } from "ahooks";
import classNames from "classnames";
import { useMemo } from "react";
import styles from "./index.module.less";

export default function SearchFilter({ filters, className, onChange }) {
  // 当前已经选择的筛选项，排除默认的综合排序
  const selectedValues = useMemo(() => {
    return filters.filter((filter) => {
      // 排除默认的综合排序
      if (filter.key === "sort") {
        return filter.value?.value !== "all";
      }

      return filter.value;
    }).length;
  }, [filters]);

  const [expand, { toggle: toggleExpand }] = useToggle(selectedValues > 0);

  return expand ? (
    <>
      <FilterGroup>
        {filters?.map((i, index) => {
          const select = (
            <FilterSelect
              onChange={(value) => {
                onChange(value, i.key, i.isFilter);
              }}
              {...i}
              key={i.key}
              name={
                i.name === "颜色" ? (
                  <img
                    width={20}
                    alt="颜色"
                    src="https://grocery-cdn.huaban.com/file/da826730e91c11efaadd17477f0bb4b9.png"
                  />
                ) : (
                  i.name
                )
              }
              className={classNames(styles.select, {
                [styles.selectFirst]: index === 0,
              })}
            />
          );
          if (i.options?.length && !i.hidden) {
            return select;
          }
          return null;
        })}
      </FilterGroup>
      <div
        onClick={toggleExpand}
        className={classNames(className, styles.expand)}
        data-gd-click="button_click"
        data-button-name="收起"
      >
        收起
        <HBIcon
          className={styles.icon}
          type="ic_chevron_left"
          style={{ fontSize: 18 }}
        />
      </div>
    </>
  ) : (
    <div
      onClick={toggleExpand}
      className={className}
      data-gd-click="button_click"
      data-button-name="筛选展开"
    >
      筛选
      {selectedValues > 0 ? (
        <span>{selectedValues}</span>
      ) : (
        <HBIcon className={styles.icon} type="more" />
      )}
    </div>
  );
}
